import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  xpModalVisible: false
};

const resultSlice = createSlice({
  name: 'result',
  initialState,
  reducers: {
    setVisibleXpModal: (state, action: PayloadAction<boolean>) => {
      state.xpModalVisible = action.payload;
    }
  }
});

export const resultReducer = resultSlice.reducer;
export const { setVisibleXpModal } = resultSlice.actions;
